import { InfoCircleOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';

export function StepGeneralSchedulingHorizonHelp() {
  const { t } = useTranslation('maintenance');

  return (
    <aside
      className="inline-info-note"
      aria-label={t('wizard.general.schedulingHorizonHelp.title')}
      style={{
        width: 'fit-content',
        maxWidth: '32rem',
        flexShrink: 1,
      }}
    >
      <InfoCircleOutlined className="inline-info-note__icon" aria-hidden />
      <div className="inline-info-note__body">
        <p className="inline-info-note__lead">
          <span className="inline-info-note__label">
            {t('wizard.general.schedulingHorizonHelp.title')}
          </span>
          <span className="inline-info-note__sep" aria-hidden>
            ·
          </span>
          <span>{t('wizard.general.schedulingHorizonHelp.line1')}</span>
        </p>
        <p className="inline-info-note__meta">
          {t('wizard.general.schedulingHorizonHelp.line2')}
        </p>
      </div>
    </aside>
  );
}
